export default {
  memberCard: {
    selectLeaderButton: 'Change leader',
    deleteLeaderButton: 'Delete leader',
  },
};
